import React from 'react';

interface ConditionTextAreaProps {
    updatedConditions: {
        dropdown1: string;
        dropdown2: string;
        inputValue: string;
        condition: string;
    }[];
    updatedAggregations: {
        dropdown1: string;
        dropdown2: string;
        aggregation: string;
    }[];
    updatedSorts: {
        dropdown1: string;
        dropdown2: string;
        sort: string;
    }[];
    onChange: (value: string) => void;
}

const ConditionTextArea: React.FC<ConditionTextAreaProps> = ({ updatedConditions, updatedAggregations, updatedSorts, onChange }) => {
    const concatenatedConditions = updatedConditions.map(row => row.condition).join('&');
    const concatenatedAggregations = updatedAggregations.map(row => row.aggregation).join('&');
    const concatenatedSorts = updatedSorts.map(row => row.sort).join('&');

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e.target.value);
    };

    const concatenatedData = `${concatenatedConditions}&${concatenatedAggregations}&${concatenatedSorts}`
        .replace(/&+$/g, '')
        .replace(/^&+/, ''); // todo auto fill also the other textarea pls

    return (
        <textarea
            value={concatenatedData}
            onChange={handleChange}
            rows={5}
            style={{ width: "97%", margin: "auto", display: "block" }}
        />
    );
};

export default ConditionTextArea;
